// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"Loader_loader-wrapper__89Iv2"};